module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAD1BMVEUAAADUKirlMy/lMi7lMi4t5IY0AAAABHRSTlMABojuA/bHFAAAAElJREFUeAFjgAFGZSMBBnTA5OKigCHI7OJigCHI4uLigEtwVFDIxAUNOCsyqLhgACcGhEKEUqyCWLVjtYiAO0cFMZM3oYyAmWUAyxQ4lUgfCVAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/red-plus.png
// module id = z92p
// module chunks = 215